import { FormControl, Input, TextFieldProps } from '@mui/material'
import { forwardRef } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IMaskInput } from 'react-imask'
import { useBlockBrowserAutofill } from '../../../hooks/use-block-browser-autofill'

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const PhoneNumberMask = forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: any) =>
          onChange({
            target: { name: props.name, value: value.replace(/[\s()-]/g, '') },
          })
        }
        overwrite
      />
    )
  }
)

const PhoneNumberField = ({ name }: TextFieldProps) => {
  const { control } = useFormContext()
  const { domFieldName, domFieldId, htmlInputProps } = useBlockBrowserAutofill(name)

  return (
    <Controller
      name={name ?? ''}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl variant="standard">
          <Input
            value={value}
            onChange={onChange}
            name={domFieldName}
            id={domFieldId}
            inputProps={htmlInputProps}
            inputComponent={PhoneNumberMask as any}
          />
        </FormControl>
      )}
    />
  )
}

export default PhoneNumberField
